/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_CloseInputs */

const en_dispatch_close = /** @type {(inputs: Dispatch_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_dispatch_close = /** @type {(inputs: Dispatch_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const ms_sg2_dispatch_close = /** @type {(inputs: Dispatch_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Dispatch_CloseInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_close = /** @type {((inputs?: Dispatch_CloseInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_CloseInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_close(inputs)
	if (locale === "fr") return fr_dispatch_close(inputs)
	return ms_sg2_dispatch_close(inputs)
});